import { render } from "./PayrollDirectDepositList.vue?vue&type=template&id=32239fe5"
import script from "./PayrollDirectDepositList.vue?vue&type=script&lang=js"
export * from "./PayrollDirectDepositList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__